import './BrokerModal.scss'

import React, { Component } from 'react'
import {Button, Modal} from 'react-bootstrap'
import {connectModal} from 'redux-modal'

import {resendBrokerInvite, resendBrokerUserInvite} from 'broker/redux/account'
import ConfirmButton from 'common/views/atoms/ConfirmButton/ConfirmButton'

class ConfirmResend extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleFinish = this.handleFinish.bind(this)
  }

  handleClick() {
    if (this.props.initialState.contact_type) {
      this.props.dispatch(resendBrokerUserInvite(this.props.initialState.hash))
    } else {
      this.props.dispatch(resendBrokerInvite(this.props.initialState.broker_invite_hash, this.props.initialState.broker_inbound_hash))
    }
    return true
  }

  handleFinish() {
    this.props.handleHide()
  }

  render() {
    return (
      <Modal className="BrokerModal" show={this.props.show}>
          <Modal.Header>
              <Modal.Title>Resend Invite?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="text">Are you sure you want to resend an invite to <a>{this.props.initialState.email}</a>?</div>
          </Modal.Body>

          <Modal.Footer>
            <div className="pull-right"><ConfirmButton onSubmit={this.handleClick} onFinish={this.handleFinish} timeouts={2000} initialText="Yes" pendingText="Sending" completeText="Sent" /></div>
            <Button className="pull-right btn-pad-right" onClick={this.props.handleHide}>Cancel</Button>
          </Modal.Footer>
      </Modal>
    )
  }
}
const ConfirmResendModal = connectModal({ name: 'ConfirmResendModal', destroyOnHide: true })(ConfirmResend)

export default ConfirmResendModal
